import type { AppSettings } from './AppSettings.js';

import { createState } from '@elara/client-core/lib/signals-utils';

export function createAppState(settings: AppSettings) {
  const state = createState({
    debugMode: settings.debugMode,
    toggleDebugMode() {
      this.debugMode = !this.debugMode;
      console.info('[AppState] Debug mode:', this.debugMode);
    },
  });
  return state;
}

export type AppState = ReturnType<typeof createAppState>;
